module.exports = __webpack_public_path__ + "static/media/vgu-login-banner4.66570da8.jpg";